import {
  FETCH_USERROLESLIST_REQUEST,
  FETCH_USERROLESLIST_SUCCESS,
  FETCH_USERROLESLIST_FAILURE,
} from "./userRolesTypes";
import api from "../../utils/Api";
import axios from 'axios';

export const fetchUserRolesListRequest = () => {
  return {
    type: FETCH_USERROLESLIST_REQUEST,
  };
};

export const fetchUserRolesListSuccess = (usersList) => {
  return {
    type: FETCH_USERROLESLIST_SUCCESS,
    payload: usersList,
  };
};

export const fetchUserRolesListFailure = (error) => {
  return {
    type: FETCH_USERROLESLIST_FAILURE,
    payload: error,
  };
};

const CancelToken = axios.CancelToken;
let cancelRequest;
export const fetchUserRolesList = (searchKey, sortBy, page) => {
  //cancel previous request if multiple hits done.
  cancelRequest && cancelRequest();
  const headers = {
    Authorization:
      "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
  };
  return async (dispatch) => {
    dispatch(fetchUserRolesListRequest);
    try {
      const response = await api.get(
        "user/role/fetch?search_key=" +searchKey + "&sort_by=" + sortBy + "&page=" + page,
        {
          headers: headers,
          cancelToken: new CancelToken(function executor(c) {
            cancelRequest = c;
        })
        }
      );
      const userRolesList = response.data.user;
      dispatch(fetchUserRolesListSuccess(userRolesList));
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('Error: ', error.message); // => prints: Api is being canceled
      } 
      console.log("Redux error - ", error.response);
      const errorMsg = error.message;
      dispatch(fetchUserRolesListFailure(errorMsg));
    }
  };
};
